import { Injectable } from '@angular/core'
import { Store, Action } from '@ngrx/store'

import * as EventTicketPurchasesSelectors from './event-ticket-purchases.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { EventTicketPurchasesState } from './event-ticket-purchases.reducer'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPurchasesFacade implements GbBaseFacade {
  currentAmount$ = this.store.select(EventTicketPurchasesSelectors.selectCurrentAmount)
  selectedPurchase$ = this.store.select(EventTicketPurchasesSelectors.selectedEventTicketPurchase)
  selectedPurchaseId$ = this.store.select(EventTicketPurchasesSelectors.selectSelectedId)
  selectedPurchaseEventTickets$ = this.store.select(EventTicketPurchasesSelectors.selectedPurchaseEventTickets)
  selectedPurchaseCustomFields$ = this.store.select(EventTicketPurchasesSelectors.selectedPurchaseCustomFields)

  constructor(private store: Store<EventTicketPurchasesState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
